import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=a87b5b6a&scoped=true"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
import style0 from "./Part.vue?vue&type=style&index=0&id=a87b5b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87b5b6a",
  null
  
)

export default component.exports